<template>
    <section class="platform-logos">
      <div class="logo-list">
        <div
  v-for="(logo, index) in logos"
  :key="index"
  class="logo-wrapper"
  :class="{ soon:  index === 4 }"
>
  <img :src="logo" alt="Platform logo" />
</div>

      </div>
    </section>
   
  </template>
  
  <script>
  export default {
    name: "PlatformLogos",
    data() {
      return {
        logos: [
          require("@/assets/android.png"),
                    require("@/assets/google.png"),
          require("@/assets/firetv.png"),
          require("@/assets/samsung1.png"),
          require("@/assets/lg.png"),
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .platform-logos {

  background-color:rgb(2, 7, 22);
    padding: 20px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  
  .logo-list {
    display: flex;
    gap: 60px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    margin:20px;
  }
  
  .logo-list img {
    height: 40px;

    opacity: 1;
    transition: all 0.3s ease;
  }
  
  .logo-list img:hover {
   
    opacity: 1;
    transform: scale(1.05);
    cursor: pointer;
  }
  
  /* 📱 Responsive stilovi */
  @media (max-width: 768px) {
    .logo-list {
      gap: 20px;
    }
  
    .logo-list img {
      height: 45px;
    }
  }
  
  @media (max-width: 480px) {
    .logo-list {
      flex-direction: row;
      gap: 20px;
    }
  
    .logo-list img {
      height: 45px;
    }
  }
  .logo-wrapper {
  position: relative;
  display: inline-block;
}

.logo-wrapper.soon::after {
  content: "Coming Soon";
  position: absolute;
  top: -10px;
  right: -25px;
  background: #ff0066;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 6px;
}

  </style>
  